export const SearchEngines: string[] = [
  'google.com',
  'bing.com',
  'yahoo.com',
  'yandex.com',
  'duckduckgo.com',
  'ask.com',
];
